<div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12">
        <div class="home-tab">
          
          <div class="row">
            <div class="col-lg-12 d-flex flex-column">
              
              <div class="row flex-grow">
                <div class="col-12 grid-margin stretch-card">
                  <div class="card card-rounded">
                    <div class="card-body">
                      <div class="d-sm-flex justify-content-between align-items-start">
                        <div>
                          <h4 class="card-title card-title-dash">Latest Subscriptions</h4>
                         <!-- <p class="card-subtitle card-subtitle-dash">You have 50+ new requests</p> -->
                        </div>
                        <!-- <div>
                          <button class="btn btn-primary btn-lg text-white mb-0 me-0" type="button"><i class="mdi mdi-account-plus"></i>Add new member</button>
                        </div> -->
                      </div>
                      <div class="table-responsive  mt-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>User</th>
                              <th>Subscription</th>
                              <th>Start Date</th>
                              <th>End Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let purchase of purchases">
                              <td>
                                <h6>{{purchase.first_name+ " "+ purchase.last_name}}</h6>
                                <!-- <p>company type</p> -->
                              </td>
                              <td>
                                {{purchase.description}}
                              </td>
                              <td>
                                {{purchase.trial_start_date}}
                              </td>
                              <td>
                                {{purchase.trial_end_date}}
                              </td>
                              <td>
                                {{purchase.status}}
                              </td>
                              <!-- <td><div class="badge badge-opacity-warning">In progress</div></td> -->
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 d-flex flex-column">
              <div class="row flex-grow">
                <div class="col-12 grid-margin stretch-card">
                  <div class="card card-rounded">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <h4 class="card-title card-title-dash">Latest Users</h4>
                            </div>
                          </div>
                          <div class="mt-3">
                            <div *ngFor="let user of users" class="wrapper d-flex  w-100 align-items-center justify-content-between py-2 border-bottom">
                              <div class="d-flex w-100">
                                <img class="img-sm rounded-10" src="assets/brand/profile.png" alt="profile">
                                <div class="wrapper w-100 ms-3">
                                  <p class="ms-1 mb-1 fw-bold d-flex"><span>{{user.first_name +' '+ user.last_name}}</span> <span class="badge badge-opacity-success ms-auto" *ngIf="user.rolename && user.rolename!=''">{{user.rolename}}</span></p>
                                  <p class="ms-1 mb-1"><span class="me-2" *ngIf="user.plan" >{{user.plan.description}}</span> </p>
                                  <!-- <small class="text-muted mb-0">162543</small> -->
                                </div>
                              </div>
                              <!-- <div class="text-muted text-small">
                                1h ago
                              </div> -->
                            </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-8 d-flex flex-column">
              
              <div class="row flex-grow">
                <div class="col-12 grid-margin stretch-card">
                  <div class="card card-rounded">
                    <div class="card-body">
                      <div class="d-sm-flex justify-content-between align-items-start">
                        <div>
                          <h4 class="card-title card-title-dash">Latest Videos</h4>
                         <!-- <p class="card-subtitle card-subtitle-dash">You have 50+ new requests</p> -->
                        </div>
                        <!-- <div>
                          <button class="btn btn-primary btn-lg text-white mb-0 me-0" type="button"><i class="mdi mdi-account-plus"></i>Add new member</button>
                        </div> -->
                      </div>
                      <div class="table-responsive  mt-1">
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Thumbnail</th>
                              <th>Title</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let video of videos">
                              <td>
                                <div class="d-flex ">
                                  <img src="assets/images/{{video.video_thumb}}" alt="">
                                  <div>
                                    <!-- <h6>{{video.title}}</h6> -->
                                    <!-- <p>Head admin</p> -->
                                  </div>
                                </div>
                              </td>
                              <td>
                                <h6>{{video.name}}</h6>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>